// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Employee_wrapper__69oVI","photoWrapper":"Employee_photoWrapper___UEqO","photo":"Employee_photo__E6w10","name":"Employee_name__x3KNh","title":"Employee_title__F_S9C"};